<template>
  <div v-if="isShow">
    <!-- 右下角图标 -->
    <!-- <div class="zoom-box">
      <img class="zoom-animation zoom-re" src="../../static/redbag/redbag_icon.png" alt="" @click="onOnce" />
    </div> -->
    <div class="rb-bg rb-ma">
      <div class="zoomred-animation rb-zzbg">
        <img src="../../static/redbag/bg.png" alt="" />
      </div>

      <div class="rb-m rb-ma">
        <div class="rb-txxx-close">
          <close-circle-outlined @click="onClose" class="rbclose" style="font-size: 22px; cursor: pointer" />
        </div>
        <!-- 未参与 -->
        <div class="zoomred-animation" style="position: relative; display: flex; flex-direction: column; align-items: center" v-if="isJoin == 1">
          <div class="rb-img ggaabg" @click="getGift">
            <div class="rb-jebox">
              <div class="rb-sjhbbt tsxx">{{ $t('_zcyl._zcbt') }}</div>
            </div>
            <img src="../../static/redbag/redbag.png" alt="" />
          </div>
          <div class="rb-amount">{{ $t('_zcyl._djdkhb') }}</div>
        </div>

        <template v-if="isJoin == 2">
          <!-- 已参与 -->
          <div class="zoomred-animation" style="position: relative">
            <div class="rb-img ggaabg" @click="getGift">
              <div class="rb-jebox">
                <div class="rb-sjhbbt tsxx">{{ $t('_zcyl._zclj') }}</div>
                <div class="rb-amount">${{ data.value }}</div>
              </div>
              <img src="../../static/redbag/redbag.png" alt="" />
            </div>
          </div>

          <!-- 去注册 -->
          <div style="margin-top: 10px" v-if="!isLogin">
            <span style="color: #ffffff">{{ $t('_zcyl._hmyzh') }} </span>
            <a style="color: #ffe000" @click="handleRegister">{{ $t('_zcyl._qzc') }}>></a>
          </div>
        </template>

        <!-- 提示消息 -->
        <div class="zoomred-animation" style="position: relative" v-if="isJoin == 3">
          <div class="rb-jebox">
            <div class="rb-sjhbbt">{{ result.msg }}</div>
            <!-- <div class="rb-jetext">商家红包，开店立即优惠</div> -->
          </div>
          <div class="rb-img">
            <img src="../../static/redbag/redbag.png" alt="" />
          </div>
        </div>

        <!-- <div class="rb-bbox" style="margin-top: 25px">
          <div class="rb-btn" @click="onReceive" v-if="isLogin && result.code == 0">{{ $t('_sjdhb._ljlq') }}</div>
          <div class="rb-btn" @click="onSignupReceive" v-else-if="isSignup">{{ $t('_sjdhb._ljlq') }}</div>
        </div> -->
      </div>
    </div>
  </div>

  <!-- 登录弹框 -->
  <login ref="loginBox" @signinSuccess="signinSuccess" @signupSuccess="signupSuccess"></login>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
import Login from './Login.vue'
export default {
  name: 'RedBagVue',
  components: {
    CloseCircleOutlined,
    Login
  },
  data() {
    return {
      isShow: false, //整个组件显示

      //是否登录
      isLogin: false,
      sp_info: {},

      //红包
      result: {},

      isJoin: 0,
      data: {
        status: 0,
        msg: '',
        code: '',
        value: '',
        uuid: '',
        inv_code: ''
      },

      //红包码
      code: '',

      //发送验证码
      hasSend: true,
      codeBtnText: this.$t('base.send.code')
    }
  },
  created() {},
  methods: {
    show(code) {
      //获取红包
      this.isShow = true
      this.code = code
      this.init()
      // this.tokenStatus()
    },
    onClose() {
      this.isShow = false
      this.isJoin = 0
    },
    /**
     * 登录成功
     */
    tokenStatus() {
      this.isLogin = this.$common.isLogin()
      this.sp_info = this.$common.getInfo()
    },
    async init() {
      //判断是否重复获取过
      const code = localStorage.getItem(this.$Const.KEY_GIFT_CODE + '_' + this.code)
      const tUUID = localStorage.getItem(this.$Const.KEY_GIFT_UUID + '_' + this.code)
      if (code && code == this.code && tUUID != '') {
        //自动获取
        this.getGift()
      } else {
        //获取信息状态
        await this.getGiftInfo()
        if (this.result.code == 0) {
          this.isJoin = 1
        } else {
          this.isJoin = 3
          localStorage.removeItem(this.$Const.KEY_GIFT_CODE + '_' + this.code)
          localStorage.removeItem(this.$Const.KEY_GIFT_UUID + '_' + this.code)
        }
      }
    },
    async getGiftInfo() {
      let hide = this.$message.loading({ content: 'loading...', key: 'msg' })
      let that = this
      await this.$api.gift
        .getGiftInfo({
          code: this.code
        })
        .then((res) => {
          hide()
          //获取错误
          if (res.code == 1) {
            this.$message.warning({ content: res.msg, key: 'msg' })
            return
          }
          that.result = res.data
          console.log('调试输出', this.result)
        })
    },
    getGift() {
      if (this.isJoin == 2) {
        return
      }
      //判断是否有缓存
      let tUUID = localStorage.getItem(this.$Const.KEY_GIFT_UUID + '_' + this.code)

      let hide = this.$message.loading({ content: 'loading...', key: 'msg' })

      let that = this
      this.$api.gift
        .getGift({
          code: this.code,
          uuid: tUUID
        })
        .then((res) => {
          hide()

          //获取错误
          if (res.code == 1) {
            this.$message.warning({ content: 'loading...', key: 'msg' })
            return
          }

          //活动结束了
          if (res.data.status == 1) {
            that.data = res.data
            this.isJoin = 3
            return
          }

          //正常获取
          that.data = res.data
          this.isJoin = 2

          //默认
          that.result = {
            code: 0
          }
          //缓存code
          localStorage.setItem(this.$Const.KEY_GIFT_CODE + '_' + this.code, res.data.code)
          if (res.data.uuid) {
            localStorage.setItem(this.$Const.KEY_GIFT_UUID + '_' + this.code, res.data.uuid)
          }
        })
    },
    handleRegister() {
      //判断是否获取红包
      let code = localStorage.getItem(this.$Const.KEY_GIFT_CODE + '_' + this.code)
      let uuid = localStorage.getItem(this.$Const.KEY_GIFT_UUID + '_' + this.code)
      if (!code && !uuid) {
        this.$message.warning({ content: this.$t('_zcyl._qxdjhb') })
        return
      }

      this.isLoading = true

      // 模拟注册过程
      let that = this
      setTimeout(() => {
        this.isLoading = false
        that.$refs.loginBox.show(2, that.data.inv_code, code, uuid)
        // this.$message.loading({ content: 'Redirecting to registration...' })

        // 实际项目中跳转到注册页面
        // this.$router.push({ name: 'signup', query: { code: that.data.inv_code, bonus: that.code } })
      }, 500)
    },
    signinSuccess() {},
    signupSuccess() {
      //清除缓存
      // localStorage.removeItem(this.$Const.KEY_GIFT_CODE + '_' + this.code)
      // localStorage.removeItem(this.$Const.KEY_GIFT_UUID + '_' + this.code)
      this.onClose()
    }
  }
}
</script>

<style scoped src="@/static/redbag/redbag.css"></style>
<style scoped>
.rb-srk >>> .ant-select-selector {
  height: 35px !important;
}
.rb-srk >>> .ant-select-selection-item {
  line-height: 35px !important;
}

.zoom-box {
  position: fixed;
  bottom: 5%;
  right: 5%;
  z-index: 9;
}

/* 定义动画名称和关键帧 */
@keyframes zoom {
  0% {
    transform: scale(1); /* 动画开始时的状态：正常大小 */
  }
  50% {
    transform: scale(1.2); /* 动画中间时刻的状态：放大10% */
  }
  100% {
    transform: scale(1); /* 动画结束时的状态：恢复正常大小 */
  }
}

/* 应用动画到元素上 */
.zoom-animation {
  animation: zoom 2s infinite; /* 动画名称，每次动画的持续时间，动画的循环次数 */
}

.zoom-re {
  width: 40px;
  cursor: pointer;
}

/* 定义动画名称和关键帧 */
@keyframes zoomred {
  0% {
    transform: scale(1); /* 动画开始时的状态：正常大小 */
  }
  50% {
    transform: scale(0.9); /* 动画中间时刻的状态：放大10% */
  }
  100% {
    transform: scale(1); /* 动画结束时的状态：恢复正常大小 */
  }
}

/* 应用动画到元素上 */
.zoomred-animation {
  animation: zoomred 2s infinite; /* 动画名称，每次动画的持续时间，动画的循环次数 */
}

.tsxx {
  font-size: 30px;
  color: #fff;
  font-weight: bold;
}
.ggaabg {
  cursor: pointer;
  position: relative;
}
</style>
